export default {
  title: 'Bienvenido',
  description:
    'Ahora puedes realizar tu compra de superpacks y recargas a tus amigos y familiares.',
  msisdn_description: 'Ingresa tu número',
  msisdn_error: {
    default: 'Intente de nuevo más tarde.',
    no_claro: 'El número que ingresó no pertenece a la red de Claro.',
    bad_request: 'Su número tiene que ser de 8 dígitos.'
  },
  result: {
    success: {
      title: '¡Felicidades!'
    },
    error: {
      invalid_code_input: 'Código inválido',
      invalid_code: 'El código que ingresaste no es válido. Intenta de nuevo.',
      used_code: 'El código que ingresaste ya fué utilizado. Intenta de nuevo.',
      system_error: 'El paquete no se pudo aprovisionar. Intenta de nuevo.'
    }
  },
  promo_bac: {
    title_principal: '¡Ganaste una recarga Claro!',
    description:
      '¡Felicidades, continúa utilizando tus plataformas digitales para seguir participando y ganar muchos premios más!',
    success: {
      description:
        '¡Felicidades, ganaste {package} continúa utilizando tus plataformas digitales para seguir participando y ganar muchos premios más!'
    }
  },
  cocacola_irresistible: {
    title_principal: 'Promo Irresistible con Datos Gratis',
    description: 'Sigue destapando y navegando Gratis con la Promo Irresistible',
    success: {
      description:
        'Ganaste {package}. ¡Sigue destapando y navegando Gratis con la Promo Irresistible!'
    }
  },
  pan_sinai: {
    title_principal: '!Ganaste un paquete digital Claro!',
    description:
      '¡Buen día, Pandulcero! ¡Sigue participando con la promoción y podrás ganar al instante muchos premios más!',
    success: {
      description: '¡Recibiste gracias a Pan Sinaí {package}!'
    }
  }
}
